import Image from '@atoms/Image';
import Text from '@atoms/Text';
import React from 'react';

export const ProductWhyInvest = ({ productWhyInvest }) => {
    const {
        question,
        title,
        cards,
        cardClass = 'flex flex-row xl:flex-col xl:items-start rounded-xl p-4 md:p-6 bg-basicWhite gap-x-4 md:gap-x-6 xl:gap-y-6',
        cardShadow = '0px 14px 34px 0px rgba(0, 0, 0, 0.05)',
        imagePadding,
        imageSize = 'w-10 h-10 md:w-12 md:h-12',
        bgImages
    } = productWhyInvest || {};

    const gridClass = {
        'Listed Corporate Bonds': 'grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-6 xl:gap-8',
        'Sovereign Gold Bonds': 'grid-cols-1 md:grid-cols-2 gap-8',
        'Treasury Bills': 'grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 md:gap-6 xl:gap-8',
        'G-Sec/SDL': 'grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 md:gap-6 xl:gap-8',
        'SDIs': 'grid-cols-1 md:grid-cols-2 xl:grid-cols-6 gap-4 md:gap-6 xl:gap-8',
        'FDs stand out': 'grid-cols-1 md:grid-cols-2 xl:grid-cols-6 gap-4 md:gap-6 xl:gap-8'
    };

    const ProductWhyInvestCard = (title, description, icon, col) => {
        return (
            <div className={`z-20 ${cardClass} ${col}`}
                style={{ boxShadow: cardShadow }}
            >
                <div className={`bg-basicWhite ${imagePadding} rounded-lg`}>
                    <div className={imageSize}>
                        <Image src={icon} className="w-full h-full" />
                    </div>
                </div>
                <div className="flex flex-col gap-y-2">
                    <Text
                        content={title}
                        htmlTag="h3"
                        className="text-primary-500 p3-semibold md:p2-semibold xl:p1-semibold"
                    />
                    <Text
                        content={description}
                        className="text-basicBlack p4-regular md:p3-regular xl:p2-regular"
                    />
                </div>
            </div >
        );
    };
    return (
        <section
            id="product-why-invest"
            className="relative flex flex-col w-full"
        >
            <div className="w-full py-8 md:py-12 xl:py-16 px-4 md:px-10 xl:px-16 overflow-hidden">
                <div className="flex flex-col md:flex-row justify-center items-center h4-semibold md:h3-semibold xl:h2-semibold">
                    <Text
                        content={<>{question}{' '}<span className='text-primary-500'>{title?.length > 15 ? <br className="md:hidden" /> : null}{title}?</span></>}
                        htmlTag="h2"
                        className="text-center text-gray-500"
                    />
                </div>
                <div
                    className={`mt-6 md:mt-10 xl:mt-12 grid ${gridClass?.[title]}`}
                >
                    {cards?.map(
                        ({ title, description, icon, col = 'col-span-1' }) =>
                            ProductWhyInvestCard(title, description, icon, col)
                    )}
                </div>
            </div>

            {bgImages?.left && (
                <div
                    style={{ pointerEvents: 'none' }}
                    className={`absolute hidden md:block md:-left-0 md:-top-[400px] xl:left-0 xl:-top-[330px]`}
                >
                    <Image src={bgImages?.left} />
                </div>
            )}
            {bgImages?.right && (
                <div
                    style={{ pointerEvents: 'none' }}
                    className={`absolute hidden md:block md:-bottom-[840px] md:right-0 xl:top-10 xl:right-0`}
                >
                    <Image src={bgImages?.right} />
                </div>
            )}
        </section>
    );
};
